import React from 'react';
import { FormattedMessage } from 'react-intl';
import config from 'appconfig';
import { StyledLink } from '../StyledComponents';
import { DetailsRow } from '../DetailsRowContentElements/DetailsRow';
import { messages } from '../../../messages';
import { ATLASSIAN_CLOUD, ATLASSIAN_ORGANISATION } from '../../../../../data/products/keys';
import { isAtlassianOrganisation } from '../../../../../util/mac/helpers';

export const UpdateAddressDetailsLink = ({
  isAccountHosted,
  productKey,
  externalUuid,
}: {
  isAccountHosted: boolean;
  productKey: string;
  externalUuid: string;
}) => {
  const isCloudOrOrganisation =
    productKey === ATLASSIAN_CLOUD || isAtlassianOrganisation(productKey);

  const isHostedCloudOrOrganisation = isAccountHosted && isCloudOrOrganisation;

  const getLinkHref = () => {
    if (isHostedCloudOrOrganisation) {
      const pathSegment = productKey !== ATLASSIAN_ORGANISATION ? 's' : 'o';
      return `${config.adminHubUrl}/${pathSegment}/${externalUuid}/billing/paymentdetails`;
    }
    return 'my/edit-details';
  };

  if (isHostedCloudOrOrganisation || !isCloudOrOrganisation) {
    return (
      <DetailsRow
        label={<FormattedMessage {...messages.addressDetails} />}
        value={
          <StyledLink href={getLinkHref()}>
            <FormattedMessage {...messages.updateAddressDetails} />
          </StyledLink>
        }
        dataCy="mac-address-details"
      />
    );
  }

  return null;
};
